import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import cross from "../../../assets/images/EPL_think_images/cross-image.png";

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  & > .modal-content {
    padding: 1.5rem 2rem;
    background-color: white;
    border-radius: 5px;
    width: fit-content;
    position: relative;
    margin-left: 15px;
    margin-right: 15px;

    .close-button {
      position: absolute;
      top: 0;
      right: 0;
      background-color: var(--color-paleteal);
      border-top-right-radius: 5px;
      height: 3.2rem;
      width: 3.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        height: 1.6rem;
        width: 1.6rem;
      }
    }

    @media screen and (min-width: 760px) {
      width: fit-content;
      margin: 1rem;
    }
  }
`;

const Modal = ({
  open = false,
  onClose,
  closeOnClickOutside = true,
  children,
  showCloseButton = false,
  id = "modal-parent",
}) => {
  const enhanchedChildren = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      onClose,
    })
  );
  const ref = useRef();
  useOnClickOutside(ref, () => {
    if (closeOnClickOutside) onClose();
  });
  useEffect(() => {
    if (open) {
      document.body.style.overflowX = "hidden";
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowX = "hidden";
      document.body.style.overflowY = "auto";
    }
  }, [open]);
  return open ? (
    <StyledModal onClick={(e) => e.stopPropagation()}>
      <div id={id} ref={ref} className="modal-content">
        {enhanchedChildren}
        {showCloseButton && (
          <div onClick={onClose} className="close-button">
            <img src={cross} alt="cross" />
          </div>
        )}
      </div>
    </StyledModal>
  ) : null;
};

export default Modal;
